<template>
    
    <div class="row hp-authentication-page">
        <div class="hp-bg-black-20 hp-bg-color-dark-90 col-lg-6 col-12 mm-none">
            <div class="row hp-image-row h-100 px-8 px-sm-16 px-md-0 pb-32 pb-sm-0 pt-32 pt-md-0">
                <div class="hp-logo-item m-16 m-sm-32 m-md-64 w-auto px-0 col-12">
                    <!-- <div class="hp-header-logo d-flex align-items-center">
                        <a href="#" class="position-relative">

                            <img class="hp-logo hp-sidebar-visible hp-dark-none" src="./img/favicon.png" alt="logo">
                            <img class="hp-logo hp-sidebar-visible hp-dark-block" src="./img/favicon.png" alt="logo">
                            
                            <img class="hp-logo hp-sidebar-hidden hp-dir-none hp-dark-block" src="./img/favicon.png" alt="logo">
                            <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-none" src="./img/favicon.png" alt="logo">
                            <img class="hp-logo hp-sidebar-hidden hp-dir-block hp-dark-block" src="./img/favicon.png" alt="logo">
                        </a>

                        <a href="#" target="_blank" class="d-flex">
                            <span class="hp-sidebar-hidden hp-caption fw-normal hp-text-color-primary-1">v.1.0</span>
                        </a>
                    </div> -->
                </div>

                <div class="col-12 px-0">
                    <div class="row h-100 w-100 mx-0 align-items-center justify-content-center bg-1" style="background-size: cover; background-repeat: no-repeat; background-position: start;">
                        <div class="hp-bg-item text-center mb-32 mb-md-0 px-0 col-12">
                            <div style="display: flex; justify-content: center; align-items: center; margin-top: 400px;">
                                <img src="../assets/img/logo_big.png" alt="" width="120px">
                                <h1 class="titleH" style="text-align: center; color: #fff; font-size: 90px; margin-top: 50px; margin-left: -25px;">aesnap</h1>
                            </div>
                        </div>

                        <div class="hp-text-item text-center col-xl-9 col-12">
                            <h2 class="hp-text-color-blac-100 hp-text-color-dark-0 mx-16 mx-lg-0 mb-16" style="color: #fff;"> </h2>
                            <p class="h4 mb-0 fw-normal hp-text-color-blac-80 hp-text-color-dark-30" style="color: #fff;"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-6 py-sm-64 py-lg-0">
            <div class="row align-items-center justify-content-center h-100 mx-4 mx-sm-n32">
                <div class="col-12 col-md-9 col-xl-7 col-xxxl-5 px-8 px-sm-0 pt-24 pb-48">

                    <!-- <div style="display: flex; justify-content: center; align-items: center;" class="dd-none">

                        <img src="../assets/img/favicon.png" alt="" style="width: 70px; margin-bottom: 5px;" class="dd-none">

                    </div> -->
                    
                    <h1 class="mb-0 mb-sm-24 mainTitle mm-none titleH" style="margin-top: 30px; " >Forgot Password</h1>
                    <h1 class="mb-0 mb-sm-24 mainTitle dd-none titleH" style="margin-top: -40px; " >Forgot Password</h1>

                    <p class=" text-black-60 subTitle" style=" margin-bottom: 40px;">Enter the email address you used to register. We'll send you an email to help you reset your password. Remember to check your <strong class="text-black-80">SPAM</strong> or <strong class="text-black-80">JUNK</strong> folder if you do not see the email in your primary inbox</p>
                    

                    <form class="mt-16 mt-sm-32 mb-8" @submit.prevent="sendEmail">

                        <div class="mb-16">
                            <label for="registerEmail" class="form-label">Email</label>
                            <input type="email" class="form-control" id="registerEmail" style="padding-top: 5px; padding-bottom: 5px;" placeholder="youremail@example.com" required v-model="email">
                        </div>

                        

                        <button type="submit" class="btn btn-primary w-100" style="color: #fff; margin-top: 30px; padding-top: 20px; padding-bottom: 20px; font-size: larger;">
                            Submit
                        </button>
                    </form>

                    <div class="col-12 hp-form-info text-center" style="margin-top: 20px; margin-bottom: 180px;">
                        <p>Not a member yet? <router-link :to="{name: 'sign-up'}" class="hp-text-color-dark-primary-2" style="color: #9146ff;"><strong>Sign up</strong></router-link></p>
                        
                    </div>

                    <div class="mt-48 mt-sm-96 col-12">

                        <div class="dd-none" style="margin-top: 100px;"></div>
                        <div class=" divider mt-18 mb-24" ></div>

                        <div style="display: flex; justify-content: space-evenly; align-items: center; width: 100%;">
                

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/privacy" target="_blank">Privacy</a>
                            </p>

                            <p class="hp-badge-text">•</p>

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/terms" target="_blank">Terms</a>
                            </p>

                            <p class="hp-badge-text">•</p>

                            <p class="hp-badge-text">
                                <a class="hp-badge-text" style="color: #9146ff;" href="https://www.baesnap.com/complaints" target="_blank">Complaints</a>
                            </p>

                        </div>

                        
                    </div>
                    
                </div>
            </div>
        </div>
    </div>

    <!-- MODALS -->
    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  " class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

</template>

<style scoped>

    .bg-1{
        background-image: url(../assets/img/frontpage-banner-9.png);
    }

</style>

<script>

    import { doc, setDoc, collection, query, where, getDocs, serverTimestamp, arrayUnion } from "firebase/firestore"; 
    import {getAuth, sendPasswordResetEmail, signInWithEmailAndPassword} from "firebase/auth";
    import { db } from '@/firebase';
    import { secureToken } from '@/smtp';
    import { MD5 } from "md5-js-tools";

    export default {

        data(){
            return{
                email: "",
                loadingText:"",
                errorText: "",
                successText: "",
                verifyPin: "",
                pinExpiry: "",
            }
        },

        mounted(){
            
        },

        methods:{

            textToBin(minput) {

                let input = minput.trim();

                let output = "";
                for (var i = 0; i < input.length; i++) {
                    output += input[i].charCodeAt(0).toString(2) + " ";
                }

                return output;
            },

            binToText(minput) {
                let input = minput.trim();
                return input.split(" ").map(function(elem) {
                    return String.fromCharCode(parseInt(elem, 2));
                }).join("")
            },

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
            },

            async generateResetLink(){

                const actionCodeSettings = {
                    // URL you want to redirect back to. The domain (www.example.com) for
                    // this URL must be whitelisted in the Firebase Console.
                    url: 'https://www.baesnap.com/sign-in',
                    // This must be true for email link sign-in.
                    handleCodeInApp: true,
                    iOS: {
                        bundleId: 'com.example.ios',
                    },
                    android: {
                        packageName: 'com.example.android',
                        installApp: true,
                        minimumVersion: '12',
                    },
                    // FDL custom domain.
                    dynamicLinkDomain: 'www.baesnap.com',
                };

                getAuth()
                .generatePasswordResetLink(this.email, actionCodeSettings)
                .then((link) =>{
                    console.log("LINK: "+link);
                })
                .catch((error)=>{
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    this.errorText = "User does not exist"; 
                    console.log(error); 
                    return;
                })

                


                

            },

            checkEmail(){

            },

            sendEmail2(){

                //loading
                this.loadingText = "Sending password reset email...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();
                sendPasswordResetEmail(auth, this.email)
                .then(() => {
                    // Password reset email sent!
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.successModal.classList.add("bg-active");
                    this.successText = "Password reset email was sent successfully"; 
                    return;
                })
                .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    this.errorText = "User does not exist"; 
                    console.log(errorMessage); 
                    return;
                    // ..
                });

            },

            async sendEmail(){

                //loading
                this.loadingText = "Sending password reset email...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();
                signInWithEmailAndPassword(auth, "forgot@baesnap.com", "forgotPassword")
                .then( async (data) => {

                    const q = query(collection(db, "Users"), where("email", "==", this.email));

                    const querySnapshot = await getDocs(q);
                    if(querySnapshot.docs.length > 0){
                    
                        querySnapshot.forEach((doc) => {

                            if(doc.data().verified == "no"){
                                this.$router.push({name: 'verify'});
                                return; 
                            }

                        });
                    
                        //email exists
                        sessionStorage.setItem("fEmail", this.email);
                        this.$router.push({name: 'forgot-password2'});
                        


                    

                    }
                    else{
                        this.$router.push('sign-up');
                        return;
                    }
                    
                } )


            }
        }
        
    }
</script>